module.exports = __webpack_public_path__ + "img/introduce-2-zh.49c4a76a.png";